import {zim } from '../../zegoConfig';
import { generateZegoToken } from '../utils/generateToken'; // Pastikan path ini sesuai dengan struktur project kamu

const TOKEN_TTL_SECONDS = 3600;
const ZIM_ERROR_ALREADY_LOGGED_IN = 6000111;

let currentUserId: string | null = null;
let tokenRenewalRegistered = false;

const registerTokenRenewal = () => {
  if (tokenRenewalRegistered) return;
  tokenRenewalRegistered = true;

  zim.on('tokenWillExpire', async () => {
    if (!currentUserId) return;
    try {
      await zim.renewToken(generateZegoToken(currentUserId, TOKEN_TTL_SECONDS));
      console.log('✅ Token ZIM diperbarui');
    } catch (err) {
      console.error('❌ Gagal memperbarui token ZIM:', err);
    }
  });
};

export const loginToZego = async (userId: string, username: string): Promise<boolean> => {
  registerTokenRenewal();

  const login = () => {
    console.log('🔑 Meminta token untuk userId:', userId);

    const zegoToken = generateZegoToken(userId, TOKEN_TTL_SECONDS);

    if (!zegoToken) throw new Error('Token Zego kosong');

    return zim.login(
      { userID: userId, userName: username },
      zegoToken
    );
  };

  try {
    try {
      await login();
    } catch (err: any) {
      if (err?.code !== ZIM_ERROR_ALREADY_LOGGED_IN) throw err;
      console.warn('⚠️ ZIM masih login dengan user lain, logout lalu login ulang');
      zim.logout();
      await login();
    }

    currentUserId = userId;
    console.log('✅ Login ZIM berhasil');
    return true;
  } catch (err) {
    console.error('❌ Gagal login ke ZIM:', err);
    return false;
  }
};
